import React, { Component } from 'react';
import { connect } from 'react-redux';

import './BasketItemList.scss';

import { BasketItem, BasketItemBundle } from '../';
import {
    BasketDetailsModel,
    StockTypes,
    BasketItemModel,
    ProductTypes,
    BasketCareKitAddonModel
} from 'models/Basket';
import { AppState } from 'store';
import { productHelper, stringComparer } from 'helpers';
import { BasketLoadingItem } from 'store/basket';

import { SofaPanel } from '@sofology/sofologycomponents';

interface OwnProps {
}

interface StateProps {
    basket: BasketDetailsModel | null;
    basketLoadingItems: BasketLoadingItem[];
    loadedCareKits: BasketCareKitAddonModel[];
}

class BasketItemList extends Component<OwnProps & StateProps> {

    render(): JSX.Element {
        let entries = this.props.basket?.entries.sort((a, b) => stringComparer(a.stockType, b.stockType));

        return (
            <div className='basket-items-list'>
                {
                    entries?.map((basketItem: BasketItemModel, itemIndex: number, basketEntries: BasketItemModel[]) => {
                        if (basketItem.product?.type === ProductTypes.Sofaglide) {
                            return null;
                        }

                        const careKitsInCart = productHelper.getCareKitsInCart(basketEntries);
                        const careKitsInfo = productHelper.getCareKitsInfoForProduct(careKitsInCart, basketItem.entryNumber, this.props.loadedCareKits);

                        return (
                            basketItem.hasStockType(StockTypes.ExDisplay)
                                ? <div className='basket-item-bundle__wrapper' key={basketItem.product.code}>
                                    <SofaPanel>
                                        <BasketItemBundle
                                            basketItem={basketItem}
                                            loading={this.isBasketItemLoading(basketItem)}
                                        />
                                    </SofaPanel>
                                </div>
                                : <SofaPanel key={basketItem.product.code}>
                                    <BasketItem
                                        basketItem={basketItem}
                                        loading={this.isBasketItemLoading(basketItem)}
                                        careKitsInfo={careKitsInfo}
                                    />
                                </SofaPanel>
                        );
                    })
                }
            </div>
        );
    }

    isBasketItemLoading = (basketItem: BasketItemModel) => {
        return this.props.basketLoadingItems.some((loadingItem: BasketLoadingItem) => loadingItem.id === basketItem.product.code);
    };
}

function mapStateToProps(state: AppState): StateProps {
    return {
        basket: state.basketState.basket,
        basketLoadingItems: state.basketState.basketLoadingItems,
        loadedCareKits: state.basketState.loadedCareKits
    };
}

export default connect(mapStateToProps)(BasketItemList);